const PREFIX = 'top-navigation';

export const SPARTAN_PRODUCT_TOP_NAV_TRACKING = {
  section: PREFIX,
  panel: `${PREFIX}-panel`,
  header: `${PREFIX}-header`,
  modelName: `${PREFIX}-model-name`,
  modelMenu: `${PREFIX}-model-menu`,
  modelMenuViewport: `${PREFIX}-model-menu-viewport`,
  modelMenuScrollbar: `${PREFIX}-model-menu-scrollbar`,
  modelMenuBackdrop: `${PREFIX}-model-menu-backdrop`,
  modelMenuItem: (key: string) => `${PREFIX}-model-menu-item-${key}`,
  startPrice: `${PREFIX}-start-price`,
  desktopMenuList: `${PREFIX}-desktop-menu`,
  desktopMenuItem: (key: string) => `${PREFIX}-desktop-menu-item-${key}`,
  actions: `${PREFIX}-actions`,
  interested: `${PREFIX}-interested`,
  interestModal: `${PREFIX}-interest-modal`,
  interestModalBackdrop: `${PREFIX}-interest-modal-backdrop`,
  interestModalPanel: `${PREFIX}-interest-modal-panel`,
  interestModalClose: `${PREFIX}-interest-modal-close`,
  interestModalTitle: `${PREFIX}-interest-modal-title`,
  interestModalHeader: `${PREFIX}-interest-modal-header`,
  interestModalContent: `${PREFIX}-interest-modal-content`,
  interestModalFooter: `${PREFIX}-interest-modal-footer`,
  interestModalCta: `${PREFIX}-interest-modal-cta`,
  interestModalSuccess: `${PREFIX}-interest-modal-success`,
  interestModalSuccessTitle: `${PREFIX}-interest-modal-success-title`,
  interestModalSuccessFooter: `${PREFIX}-interest-modal-success-footer`,
  interestModalSuccessCta: `${PREFIX}-interest-modal-success-cta`,
  interestModalError: `${PREFIX}-interest-modal-error`,
  interestModalErrorMessage: `${PREFIX}-interest-modal-error-message`,
  interestModalErrorFooter: `${PREFIX}-interest-modal-error-footer`,
  interestModalErrorCta: `${PREFIX}-interest-modal-error-cta`,
  seeMore: `${PREFIX}-see-more`,
  mobileMenu: `${PREFIX}-mobile-menu`,
  mobileMenuBackdrop: `${PREFIX}-mobile-menu-backdrop`,
  mobileMenuList: `${PREFIX}-mobile-menu-list`,
  mobileMenuItem: (key: string) => `${PREFIX}-mobile-menu-item-${key}`,
} as const;

export const SPARTAN_PRODUCT_TOP_NAV_DATA_GA = {
  section: PREFIX,
} as const;

export const SPARTAN_PRODUCT_TOP_NAV_MOBILE_MENU_ID =
  SPARTAN_PRODUCT_TOP_NAV_TRACKING.mobileMenu;

export const SPARTAN_PRODUCT_TOP_NAV_MODEL_MENU_ID =
  SPARTAN_PRODUCT_TOP_NAV_TRACKING.modelMenu;
